import { createApiClient } from "@clinic/api-client";
import { createDemoClient } from "@/demo/client";

/** Demo mode (VITE_DEMO=1) runs the whole app against an in-memory dataset — no
 * server, database, or Docker needed. Never enabled in the Docker/prod build. */
export const IS_DEMO = import.meta.env.VITE_DEMO === "1";

/**
 * Web client relies entirely on httpOnly cookies (set by the server).
 * In dev the Vite proxy makes /api same-origin; in Docker, nginx/Caddy do.
 */
export const api = IS_DEMO
  ? createDemoClient()
  : createApiClient({
      baseUrl: import.meta.env.VITE_API_URL ?? "",
      onUnauthorized: () => {
        if (!window.location.pathname.startsWith("/login")) {
          window.location.href = "/login";
        }
      },
    });
